import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=7e9b05ac&"
import script from "./LangSelect.vue?vue&type=script&lang=js&"
export * from "./LangSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7e9b05ac', component.options)
    } else {
      api.reload('7e9b05ac', component.options)
    }
    module.hot.accept("./LangSelect.vue?vue&type=template&id=7e9b05ac&", function () {
      api.rerender('7e9b05ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/components/lang-select/LangSelect.vue"
export default component.exports